import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "15",
      height: "15",
      x: "1.5",
      y: "1.5",
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-width": "3",
      rx: "7.5"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#EE4925",
      "fill-rule": "evenodd",
      d: "M9 15A6 6 0 1 0 9 3a6 6 0 0 0 0 12m2.118-8.118a.45.45 0 0 1 0 .636L9.636 9l1.482 1.482a.45.45 0 0 1-.636.636L9 9.636l-1.482 1.482a.45.45 0 0 1-.636-.636L8.364 9 6.882 7.518a.45.45 0 0 1 .636-.636L9 8.364l1.482-1.482a.45.45 0 0 1 .636 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }